/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from "#client";
import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type {
	ProductsRetrievePathOrgUnitId,
	ProductsRetrievePathProductId,
	ProductsRetrieveQueryAttachLogs,
	ProductsRetrieveQueryUseHotMenu,
	ProductsRetrieveStatus200,
} from "../types/ProductsRetrieve.ts";

function getProductsRetrieveUrl(org_unit_id: ProductsRetrievePathOrgUnitId, product_id: ProductsRetrievePathProductId) {
	const res = { method: "GET", url: `/api/${org_unit_id}/products/${product_id}` as const };

	return res;
}

/**
 * {@link /api/:org_unit_id/products/:product_id}
 */
export async function productsRetrieve(
	org_unit_id: ProductsRetrievePathOrgUnitId,
	product_id: ProductsRetrievePathProductId,
	params?: { attach_logs?: ProductsRetrieveQueryAttachLogs; use_hot_menu?: ProductsRetrieveQueryUseHotMenu },
	config: Partial<RequestConfig> & { client?: Client } = {},
) {
	const { client: request = client, ...requestConfig } = config;

	const res = await request<ProductsRetrieveStatus200, ResponseErrorConfig<Error>, unknown>({
		method: "GET",
		url: getProductsRetrieveUrl(org_unit_id, product_id).url.toString(),
		params,
		...requestConfig,
	});

	return res.data;
}
